import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { map, tap } from 'rxjs';

import { ApiPartnerPaymentsService } from '../services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { PartnerPaymentMethodsResponse, GetPaymentMethodsResponse, PartnerPaymentsResponse, PartnerPaymentsStateModel, PaymentMethod } from '../models';
import { PartnerPaymentsActions } from '../actions';
import { PaymentsControlState } from './payments-control-state';

export const partnerPaymentsStateDefaults: PartnerPaymentsStateModel = {
  paymentMethods: null,
  partnerPaymentMethods: null,
  partnerPayments: null,
  loaded: false
};

export const PARTNER_PAYMENTS_STATE_TOKEN = new StateToken<PartnerPaymentsStateModel>('partnerPayments');

@State<PartnerPaymentsStateModel>({
    name: PARTNER_PAYMENTS_STATE_TOKEN,
    defaults: partnerPaymentsStateDefaults
})

@Injectable()
export class PartnerPaymentsState extends PaymentsControlState implements NgxsOnInit {

  constructor(
    private service: ApiPartnerPaymentsService,
    snackbar: SnackbarService
  ) {
    super(snackbar)
  }

	ngxsOnInit(): void {
	}

  @Selector()
  static paymentMethods(state: PartnerPaymentsStateModel): PaymentMethod[] {
    return state.paymentMethods!;
  }

  @Selector()
  static partnerPaymentMethods(state: PartnerPaymentsStateModel): PaymentMethod[] {
    return state.partnerPaymentMethods!;
  }

  @Action(PartnerPaymentsActions.GetPaymentMethods)
  getPaymentMethods(ctx: StateContext<PartnerPaymentsStateModel>) {
    return this.service.getPaymentMethods().pipe(
      map((response: GetPaymentMethodsResponse) => response.data.paymentMethods),
      tap((paymentMethods: PaymentMethod[]) => ctx.patchState({ paymentMethods, loaded: true })),
      this.catchResponse
    );
  }

  @Action(PartnerPaymentsActions.GetPartnerPaymentMethods)
  getPartnerPaymentMethods(ctx: StateContext<PartnerPaymentsStateModel>, action: PartnerPaymentsActions.GetPartnerPaymentMethods ) {
    return this.service.getPartnerPaymentMethods(action.partnerId).pipe(
      map((response: PartnerPaymentMethodsResponse) => response.data),
      tap((data: PartnerPaymentsResponse) => ctx.patchState({
        partnerPayments: data.paymentsPartner,
        partnerPaymentMethods: data.paymentMethods,
        loaded: true
      })),
      this.catchResponse
    )
  }

  @Action(PartnerPaymentsActions.UpdatePartnerPaymentMethods)
  updatePartnerPaymentMethods(ctx: StateContext<PartnerPaymentsStateModel>, action: PartnerPaymentsActions.UpdatePartnerPaymentMethods ) {
    return this.service.updatePartnerPaymentMethods(action.partnerId, action.paymentMethodIds).pipe(
      map((response: PartnerPaymentMethodsResponse) => response.data),
      tap((data: PartnerPaymentsResponse) => ctx.patchState({
        partnerPayments: data.paymentsPartner,
        partnerPaymentMethods: data.paymentMethods
      })),
      this.catchResponse
    )
  }

}
